import { SET_REFERER } from "./type";

export const setReferer = (referer: string) => {
  return {
    type: SET_REFERER,
    referer
  };
};
